import React from 'react'
import I18n from 'lib/i18n'

export default function Reputaion () {
  return (
    <div className='row reputation-part'>
      <div className='twelve.columns'>
        <div className='content-box clearfix'>
          <div className='left-part'>
            <div className='not-responsive-inline-block' style={{ maxWidth: 306, margin: '0 auto' }}>
              <img
                className='drop-shadow retina lazyload'
                data-src={`/assets/pages/how1/reputation-${I18n.locale === 'fr' ? 'fr' : 'en'}.png`}
                data-retina={`/assets/pages/how1/reputation-${I18n.locale == 'fr' ? 'fr' : 'en'}@2x.png`}
                style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
                alt=''
              />
            </div>
          </div>
          <div className='right-part'>
            <h3 dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.teachers_reputation_title') }} />
            <div className='only-responsive-inline-block' style={{ maxWidth: 306, margin: '0 auto' }}>
              <img
                className='drop-shadow retina lazyload'
                data-src={`/assets/pages/how1/reputation-${I18n.locale === 'fr' ? 'fr' : 'en'}.png`}
                data-retina={`/assets/pages/how1/reputation-${I18n.locale == 'fr' ? 'fr' : 'en'}@2x.png`}
                style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
                alt=''
              />
            </div>
            <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.teachers_reputation') }} />
          </div>
        </div>
      </div>
    </div>
  )
}
